import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '12px',
  },
  label: {
    fontSize: '14px',
    color: 'rgba(39, 58, 57, 0.8)',
  },
  group: {
    fontSize: '12px',
  },
  controlLabel: {
    '& span': {
      fontSize: '12px',
    },
    marginRight: theme.spacing(3),
  },
  control: {
    fontSize: '12px',
    '& svg': {
      fill: '#65ac1f'
    }
  }
}));